import React, { useState } from "react";
import "./CalculatorContainer.css";
import EntrypointForm from "./EntrypointForm";
import CalculatorResults from "./CalculatorResults";

export default function CalculatorContainer() {
  const [form, setForm] = useState();
  const [view, setView] = useState("form");

  const handleSubmit = (newForm) => {
    console.log(newForm);
    setForm(newForm);
    setView("results");
  };

  return (
    <div className="flex flex-col items-center h-full p-5 border border-blue-500 border-solid calculator-container min-w-80 text-gray-other">
      {view === "form" ? <EntrypointForm onSubmit={handleSubmit}></EntrypointForm> : null}
      {view === "results" ? <CalculatorResults form={form}></CalculatorResults> : null}
    </div>
  );
}
